import { BusTransferService } from "../../../utility/tdtService/BusTransfer/BusTransferService.js";
import { DriveService } from "../../../utility/tdtService/Drive/DriveService.js"
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs.js";
import { SystemConfig } from "../../../config/SystemConfig.js";

/**
 * 路线筛选条件
 */
export class RouteFilter {
    constructor() {
        this.startPositionX = -1;
        this.startPositionY = -1;
        this.endPositionX = -1;
        this.endPositionY = -1;
        //筛选类型
        this.filterType = null;
        //换乘类型
        this.transferType = null;

        //驾车途经点坐标字符串
        this.driveViaCoorString = "";

        this.token =SystemConfig.token; 
    }
}

/**
 * 路线搜索结果
 */
export class RouteSearchResult {
    constructor() {
        this.id = null;

        this.resultType = null;

        this.resultObject = null;
    }

    static createFromNationalBus(busTransfer) {
        let searchResult = new RouteSearchResult();

        searchResult.resultType = RouteType.national_busTransfer;
        searchResult.resultObject = busTransfer;

        return searchResult;
    }

    static createFromNationalDriver(drive) {
        let searchResult = new RouteSearchResult();

        searchResult.resultType = RouteType.national_drive;
        searchResult.resultObject = drive;

        return searchResult;

    }

    static search(filter, succeedCallback, errorCallback) {
        if (!filter) return;

        if (filter.filterType === RouteType.national_busTransfer) {
            let busService = new BusTransferService();
            
            busService.tdtURL=ServiceUrlConfig.tdt_service_busTransfer_url;
            busService.startPositionX = filter.startPositionX;
            busService.startPositionY = filter.startPositionY;
            busService.endPositionX = filter.endPositionX;
            busService.endPositionY = filter.endPositionY;
            busService.transferType = filter.transferType;
            busService.token = filter.token;
            busService.Transfer(function (transferInfo) {
                let routeResult = RouteSearchResult.createFromNationalBus(transferInfo);
                if (succeedCallback) {
                    succeedCallback(routeResult);
                }
            },
                function (error) {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
            );
        }
        else if (filter.filterType === RouteType.national_drive) {
            let drive = new DriveService();
            drive.tdtURL=ServiceUrlConfig.tdt_service_drive_url;
            drive.destLat = filter.endPositionY;
            drive.destLon = filter.endPositionX;
            drive.origLat = filter.startPositionY;
            drive.origLon = filter.startPositionX;
            drive.style = filter.transferType;
            drive.token = filter.token;
            drive.mid = filter.driveViaCoorString;
            drive.Drive(function (routeInfo) {
                if (succeedCallback) {
                    let routeResult = RouteSearchResult.createFromNationalDriver(routeInfo);
                    succeedCallback(routeResult);
                }
            },
                function (error) {
                    if (errorCallback) {
                        errorCallback(error);
                    }

                }

            );
        }

    }

}




/**
 * 路径类型
 */
export const RouteType =
{

    /**
     * 国家天地图公交换乘
     */
    national_busTransfer: "national_busTransfer",

    /**
     * 国家天地图乘车
     */
    national_drive: "national_drive"

}